module.exports = __webpack_public_path__ + "static/media/fast-icon.d3b48940.svg";